
import api from './api';

const endpoint = '/api/faltas';

const FaltasService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getAtivos: async () => {
    const response = await api.get(`${endpoint}/ativos`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },

  create: async (id) => {
    const response = await api.post(`${endpoint}/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${endpoint}/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default FaltasService;